export default __webpack_public_path__ + "static/media/paint-util.a1c4ef84.svg";